import { render, staticRenderFns } from "./addNewProduct.vue?vue&type=template&id=a28a846e&scoped=true"
import script from "./addNewProduct.vue?vue&type=script&lang=js"
export * from "./addNewProduct.vue?vue&type=script&lang=js"
import style0 from "./addNewProduct.vue?vue&type=style&index=0&id=a28a846e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28a846e",
  null
  
)

export default component.exports